export const enum IconParseTypes {

    SERVICE_CATEGORY = 'service_category',

}
